(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-compact-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-velora-compact-hero]').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const track=root.querySelector('.velora-compact-hero__track');
    const dots=Array.from(root.querySelectorAll('[data-hero-dot]'));
    const pause=root.querySelector('[data-hero-pause]');
    if(!track || dots.length<2 || !pause) return;
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let playing=!motion.matches;
    let active=0;
    const syncPause=() => {pause.setAttribute('aria-label',playing?'Pausar carrusel':'Reproducir carrusel');pause.querySelector('span').textContent=playing?'Ⅱ':'▶';};
    const stop=() => {playing=false;syncPause();};
    const go=index => track.scrollTo({left:track.clientWidth*index,behavior:motion.matches?'instant':'smooth'});
    dots.forEach((dot,index)=>dot.addEventListener('click',()=>{stop();go(index);}));
    pause.addEventListener('click',()=>{playing=!playing;syncPause();});
    track.addEventListener('pointerdown',stop,{passive:true});
    track.addEventListener('keydown',stop);
    root.addEventListener('focusin',event=>{if(event.target!==pause)stop();});
    track.addEventListener('scroll',()=>{
      active=Math.round(track.scrollLeft/track.clientWidth);
      dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===active)));
    },{passive:true});
    const timer=setInterval(()=>{
      if(!root.isConnected){clearInterval(timer);return;}
      const rect=root.getBoundingClientRect();
      if(playing && !document.hidden && !root.matches(':hover') && rect.bottom>0 && rect.top<innerHeight)go((active+1)%dots.length);
    },6500);
    syncPause();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-countdown-bar"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('velora-cyber-start')) {
  customElements.define('velora-cyber-start', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.abort = new AbortController();
      this.deadline = Date.parse(this.dataset.deadline);
      if (!Number.isFinite(this.deadline)) { this.hidden = true; return; }
      this.update = () => {
        const remaining = Math.max(0, this.deadline - Date.now());
        const time = this.querySelector('[data-cyber-time]');
        if (remaining === 0) {
          this.querySelector('[data-cyber-label]').textContent = this.dataset.activeLabel;
          time.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const seconds = Math.ceil(remaining / 1000);
        this.querySelector('[data-cyber-hours]').textContent = String(Math.floor(seconds / 3600)).padStart(2, '0');
        this.querySelector('[data-cyber-minutes]').textContent = String(Math.floor(seconds / 60) % 60).padStart(2, '0');
        this.querySelector('[data-cyber-seconds]').textContent = String(seconds % 60).padStart(2, '0');
        time.hidden = false;
      };
      this.update();
      if (Date.now() < this.deadline) this.timer = setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.update, { signal: this.abort.signal });
      window.addEventListener('pageshow', this.update, { signal: this.abort.signal });
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-cyber-monday"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('velora-cyber-rotator')) {
  customElements.define('velora-cyber-rotator', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-cyber-slide]')];
      this.dots = [...this.querySelectorAll('[data-cyber-go]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.running = !this.motion.matches;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.show = (index, animate = true) => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.classList.toggle('is-entering', i === this.index && animate); });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      };
      this.schedule = () => { clearTimeout(this.timer); if (this.running && !this.hovering && !this.contains(document.activeElement) && !document.hidden) this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval || 15) * 1000); };
      this.toggle = this.querySelector('[data-cyber-toggle]');
      this.updateToggle = () => { this.toggle.textContent = this.running ? this.dataset.pause : this.dataset.play; this.toggle.setAttribute('aria-pressed', String(this.running)); };
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.show(i); this.schedule(); }, options));
      this.toggle.addEventListener('click', () => { this.running = !this.running; this.updateToggle(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) { this.running = false; this.updateToggle(); this.schedule(); } }, options);
      this.show(0, false); this.updateToggle(); this.schedule();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-semana-electro"]) return;
  try {
    
  const initVeloraElectro = () => {
    document.querySelectorAll('[data-velora-electro]').forEach((banner) => {
      if (banner.dataset.initialized === 'true') return;
      banner.dataset.initialized = 'true';

      const messages = Array.from(banner.querySelectorAll('[data-electro-message]'));
      const timerDisplay = banner.querySelector('[data-electro-timer]');
      const speed = Number(banner.dataset.rotationSpeed) || 4000;
      const endAt = new Date(banner.dataset.endAt).getTime();
      let current = 0;
      let rotationTimer;
      let countdownTimer;

      const showMessage = (index) => {
        messages.forEach((message, messageIndex) => {
          const isActive = messageIndex === index;
          message.classList.toggle('is-active', isActive);
          message.setAttribute('aria-hidden', String(!isActive));
        });
      };

      const stopRotation = () => {
        window.clearInterval(rotationTimer);
        rotationTimer = undefined;
      };

      const startRotation = () => {
        if (messages.length < 2 || rotationTimer) return;
        rotationTimer = window.setInterval(() => {
          current = (current + 1) % messages.length;
          showMessage(current);
        }, speed);
      };

      const updateCountdown = () => {
        const remaining = endAt - Date.now();
        if (remaining <= 0) {
          window.clearInterval(countdownTimer);
          stopRotation();
          banner.closest('.velora-electro-section')?.remove();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (value) => String(value).padStart(2, '0');

        if (timerDisplay) {
          timerDisplay.textContent = `${pad(days)}D · ${pad(hours)}H · ${pad(minutes)}M · ${pad(seconds)}S`;
        }
      };

      showMessage(current);
      updateCountdown();
      countdownTimer = window.setInterval(updateCountdown, 1000);
      startRotation();
    });
  };

  initVeloraElectro();
  document.addEventListener('shopify:section:load', initVeloraElectro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-youtube-shorts"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-vys]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const track=root.querySelector('.vys__track'),cards=[...track.querySelectorAll('.vys__card')],segments=[...root.querySelectorAll('.vys__segments span')],dialog=root.querySelector('dialog'),embed=root.querySelector('.vys__embed');let trigger,index=0;const reduced=()=>matchMedia('(prefers-reduced-motion:reduce)').matches;const step=()=>cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);const sync=()=>{segments.forEach((s,i)=>s.classList.toggle('is-active',i===index))};const go=direction=>{const max=Math.max(0,track.scrollWidth-track.clientWidth);let next=track.scrollLeft+direction*step();if(next>max+2)next=0;if(next< -2)next=max;track.scrollTo({left:next,behavior:reduced()?'auto':'smooth'})};root.querySelector('[data-vys-prev]').addEventListener('click',()=>go(-1));root.querySelector('[data-vys-next]').addEventListener('click',()=>go(1));track.addEventListener('scroll',()=>{index=Math.min(cards.length-1,Math.round(track.scrollLeft/step()));sync()},{passive:true});track.addEventListener('keydown',e=>{if(e.target===track&&(e.key==='ArrowLeft'||e.key==='ArrowRight')){e.preventDefault();go(e.key==='ArrowRight'?1:-1)}});root.querySelectorAll('[data-vys-video]').forEach(button=>button.addEventListener('click',()=>{trigger=button;document.querySelectorAll('.vys__dialog[open]').forEach(d=>d.close());const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(button.dataset.vysVideo)+'?autoplay=1&playsinline=1&rel=0';frame.title=button.dataset.vysTitle;frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.setAttribute('sandbox','allow-scripts allow-same-origin allow-presentation');embed.replaceChildren(frame);dialog.showModal();root.querySelector('[data-vys-close]').focus()}));const close=()=>{embed.replaceChildren();dialog.close()};root.querySelector('[data-vys-close]').addEventListener('click',close);dialog.addEventListener('cancel',()=>embed.replaceChildren());dialog.addEventListener('close',()=>{embed.replaceChildren();trigger?.focus()});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}})});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();
})();
